// Isomorphic VALUE formatters — one home so a phone, email, URL, or zip reads/stores the same everywhere
// (client inputs, server normalization, read-only display). Pure + DOM-free. Locale/date display formatters
// live separately in the client's lib/format.ts.
export const digitsOnly = (s) => (s ?? '').replace(/\D/g, '');
// ── Phone ───────────────────────────────────────────────────────────────────
/** Canonical store form: leading '+' (if intl) then up to 15 digits. */
export function normalizePhone(raw) {
    const s = (raw ?? '').trim();
    if (!s)
        return '';
    const plus = s.startsWith('+');
    const d = digitsOnly(s).slice(0, 15);
    if (!d)
        return '';
    return plus ? `+${d}` : d;
}
/** Human display: US `(555) 123-4567`, `+1 (555) 123-4567`, else `+44 791 112 3456`. Partials pass through. */
export function formatPhone(raw) {
    const s = (raw ?? '').trim();
    if (!s)
        return '';
    const plus = s.startsWith('+');
    const d = digitsOnly(s);
    if (!d)
        return '';
    const us = (x) => `(${x.slice(0, 3)}) ${x.slice(3, 6)}-${x.slice(6)}`;
    if (!plus && d.length === 10)
        return us(d);
    if (d.length === 11 && d.startsWith('1'))
        return `+1 ${us(d.slice(1))}`;
    // International or partial: keep the +, group remaining digits in 3s from the right.
    return (plus ? '+' : '') + d.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
// ── Email ─────────────────────────────────────────────────────────────────--
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const isEmail = (raw) => EMAIL_RE.test((raw ?? '').trim());
/** Store + display form: trimmed, lower-cased. */
export const formatEmail = (raw) => (raw ?? '').trim().toLowerCase();
// ── URL ───────────────────────────────────────────────────────────────────--
/** Store form: prepend https:// when a bare host/path was typed (leaves mailto:/tel: alone). */
export function normalizeUrl(raw) {
    const s = (raw ?? '').trim();
    if (!s)
        return '';
    if (/^[a-z][a-z0-9+.-]*:/i.test(s))
        return s; // already has a scheme
    return `https://${s}`;
}
/** Display: drop the scheme + trailing slash for a compact, readable link label. */
export function formatUrl(raw) {
    const s = (raw ?? '').trim();
    if (!s)
        return '';
    return s.replace(/^https?:\/\//i, '').replace(/\/$/, '');
}
// ── Zip ───────────────────────────────────────────────────────────────────--
/** US zip: `12345` or `12345-6789`. */
export function formatZip(raw) {
    const d = digitsOnly(raw).slice(0, 9);
    return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}
//# sourceMappingURL=format.js.map